import transitionsData from "../data/kanban_transitions.json";

export interface TransitionRule {
  from: string;
  to: string;
  roles: string[];
  requires_owner?: boolean;
  requires_reason?: boolean;
  automation?: string;
}

const rules: TransitionRule[] = (transitionsData as any).rules;

/** Client-side mirror of config/kanban_transitions.json, used only to grey
 * out invalid drop targets during drag for UX. The server remains the
 * source of truth and re-validates on every PATCH. */
export function validTargets(fromStageCode: string): string[] {
  return rules.filter((r) => r.from === fromStageCode).map((r) => r.to);
}

export function findRule(fromStageCode: string, toStageCode: string): TransitionRule | undefined {
  return rules.find((r) => r.from === fromStageCode && r.to === toStageCode);
}
